export type LFSEOfferType = 'hotels' | 'tours' | 'ultralux' | 'experiences' | 'cruises' | 'villas'

type LookingForSomethingElseContent = {
  to: string
  imageId?: string
}

export const LOOKING_FOR_SOMETHING_ELSE_CONTENT: Record<LFSEOfferType, LookingForSomethingElseContent> = {
  hotels: { to: '/hotels', imageId: 'k58oh9ebyasvjo9ndff' },
  tours: { to: '/tours', imageId: 'exu2capyq66fvv752yc4' },
  ultralux: { to: '/ultra-lux' },
  experiences: { to: '/experiences', imageId: 'ufils1y5jgf0yhvf5utk' },
  cruises: { to: '/cruises', imageId: 'wioy2m740nyf1gzxbr3v' },
  villas: { to: '/homes-and-villas' },
}
